import React, { useState } from 'react';
import PageHeader from '../components/layout/PageHeader';
import Tabs from '../components/ui/Tabs';
import Gallery from '../components/ui/Gallery';
const GalleryPage = () => {
  const campusImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg',
    alt: 'Academic buildings with landscaped gardens',
    caption: 'Academic buildings with beautiful landscaped gardens'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/guWk5XsDGYmXXcoEtCyUpd/WhatsApp_Image_2025-10-24_at_11.30.12_%281%29.jpg',
    alt: 'Campus aerial view',
    caption: 'Aerial view of our beautiful campus'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mMF9fzVCb1rew9Z9Ba8RBR/WhatsApp_Image_2025-10-24_at_11.30.12.jpg',
    alt: 'School grounds with pathways',
    caption: 'Well-maintained pathways and green lawns'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8LoteQK39b5zMuJh2pbsp8/WhatsApp_Image_2025-10-24_at_11.30.11.jpg',
    alt: 'Classroom blocks',
    caption: 'Classroom blocks with covered walkways'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4jLMnmKXSAWwavqGR8zdhM/WhatsApp_Image_2025-10-24_at_11.30.13_%281%29.jpg',
    alt: 'Boarding house',
    caption: 'Two-story boarding house with balconies'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/de3EQh38fKgVchW9xJS4du/WhatsApp_Image_2025-10-24_at_10.01.26.jpg',
    alt: 'Administrative Block',
    caption: 'Main administrative building'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oq7mq9TcPHpj2uqzCbrBtL/WhatsApp_Image_2025-10-24_at_10.01.15.jpg',
    alt: 'Principal Quarter',
    caption: 'Principal Quarter building'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/69pV2ekxejVNy9Zw2uynoL/WhatsApp_Image_2025-10-24_at_10.01.14.jpg',
    alt: 'School clinic building',
    caption: 'Modern school clinic providing healthcare services'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3pfjisMQi2bXtDgiUWndNF/WhatsApp_Image_2025-10-24_at_10.01.15.jpg',
    alt: 'School building with green lawn',
    caption: 'School building surrounded by well-maintained green lawns'
  }];
  const studentLifeImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg',
    alt: 'Cultural performance',
    caption: 'Students performing traditional cultural dance'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg',
    alt: 'Morning assembly',
    caption: 'Students at morning assembly'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3iuYwPBfNvbAqWiL5UGdQD/WhatsApp_Image_2025-08-14_at_15.45.35_%283%29.jpg',
    alt: 'Students in classroom',
    caption: 'Students in their classroom'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tXB2gESgQyPW5hZWnwiFvU/WhatsApp_Image_2025-08-08_at_06.35.51_%281%29.jpg',
    alt: 'Student in uniform',
    caption: 'Student in front of the Chemistry Laboratory'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZLbes2hxk7MhXzaZ1hXLV/WhatsApp_Image_2025-10-24_at_10.01.19.jpg',
    alt: 'School football team',
    caption: 'IGS Football Team'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/9KTZ7HUP1wb7ieQ2CeaS6b/WhatsApp_Image_2025-10-24_at_10.01.18_%281%29.jpg',
    alt: 'Athletics team',
    caption: 'Athletics team in action'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/f2xgFc9rK22wZyJ7XvkYdc/WhatsApp_Image_2025-10-24_at_10.01.18.jpg',
    alt: 'Girls cricket team',
    caption: 'IGS Girls Cricket Team with their coaches'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fqznuuu78HmKmW8bRuWFw1/WhatsApp_Image_2025-10-24_at_10.01.19.jpg',
    alt: 'Football training session',
    caption: 'Students during football training on the sports field'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fhbXs7UNN6d2HJRiEebjre/WhatsApp_Image_2025-10-24_at_10.01.20.jpg',
    alt: 'Students in classroom',
    caption: 'Students attentively learning in their classroom'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aeofuDDq4R4LzKTTb7kCTJ/WhatsApp_Image_2025-10-24_at_10.01.21.jpg',
    alt: 'Teacher with students',
    caption: 'Experienced teacher engaging with students in traditional attire'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3GFAKQjjuFe5vR4bv8XoiJ/WhatsApp_Image_2025-10-24_at_10.01.21_%281%29.jpg',
    alt: 'Computer lab session',
    caption: 'Students developing digital skills in the computer laboratory'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vKv5s2R4J3htwPZBqsE5mu/WhatsApp_Image_2025-10-24_at_10.01.23.jpg',
    alt: 'Teacher teaching students',
    caption: 'Teacher in traditional attire engaging students in classroom'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8v7HegjxEmi2KSxNec1Zxz/WhatsApp_Image_2025-10-24_at_10.01.25.jpg',
    alt: 'School sports team',
    caption: 'School sports team ready for competition on the field'
  }];
  const facilitiesImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/b9sNC2W3z8KYjzQztqrzUk/WhatsApp_Image_2025-10-24_at_10.01.23_%281%29.jpg',
    alt: 'Junior school classroom',
    caption: 'Active learning in our junior school section'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qfRUYQw3ECRPT1ECfn8AxJ/WhatsApp_Image_2025-10-24_at_10.01.23.jpg',
    alt: 'PSI/PMI class',
    caption: 'PSI/PMI pedagogy in practice'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5gKYWryVTvwM3jPw4Bpnok/WhatsApp_Image_2025-10-24_at_10.01.16.jpg',
    alt: 'Chemistry laboratory',
    caption: 'Chemistry laboratory practical session'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4bkQakMXE7oCJhU6DHfZ4v/WhatsApp_Image_2025-10-24_at_10.01.16_%281%29.jpg',
    alt: 'Computer laboratory',
    caption: 'ICT laboratory with modern computers'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/26CHK6sEK66nfVUNdvbwf4/WhatsApp_Image_2025-10-24_at_10.01.20_%282%29.jpg',
    alt: 'Teacher using technology in physics lesson',
    caption: 'Teacher demonstrating wave mechanics using digital technology'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fBcdZe3j5kT56auYSAwRFV/WhatsApp_Image_2025-10-24_at_10.01.23_%281%29.jpg',
    alt: 'Mathematics teacher at whiteboard',
    caption: 'Teacher explaining differential calculus and circle geometry'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ez9ThFy3DkQ6XwMpYtSRNQ/WhatsApp_Image_2025-10-24_at_10.01.16.jpg',
    alt: 'Students in modern laboratory',
    caption: 'Students conducting experiments in our well-equipped science laboratory'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tj13uTG1CCX8nkvziVAAab/WhatsApp_Image_2025-10-24_at_10.01.17_%281%29.jpg',
    alt: 'ICT Room sign',
    caption: 'ICT Room donated by Old Students Association 75/80 Set'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/rYxE1D1a3w1zMFiLJm2aU1/WhatsApp_Image_2025-10-24_at_10.01.17.jpg',
    alt: 'Teacher conducting chemistry lesson',
    caption: 'Teacher demonstrating chemistry concepts on the whiteboard'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kMX4mMRKhHUYMbFhqjEMu9/WhatsApp_Image_2025-10-24_at_10.01.20_%281%29.jpg',
    alt: 'Biology teacher with anatomical models',
    caption: 'Biology teacher demonstrating with anatomical models and skeleton'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tDi3zMHQVzwj3EoB8pBjyc/WhatsApp_Image_2025-10-24_at_10.01.18_%282%29.jpg',
    alt: 'School library interior',
    caption: 'Well-organized library with extensive book collection'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jA5f2egHsPW6YcMhP4RtXv/WhatsApp_Image_2025-10-24_at_10.01.18_%281%29.jpg',
    alt: 'Chemistry Lab renovation plaque',
    caption: 'Chemistry Laboratory renovated by Old Students Association 75/80 Set'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hWx5tyEVbwQVrxum4dtVj3/WhatsApp_Image_2025-10-24_at_13.20.17_%281%29.jpg',
    alt: 'Science laboratory practical session',
    caption: 'Students conducting experiments in the modern science laboratory'
  }];
  const achievementsImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hLZSXSdtdK6mk3VNd7a3xR/WhatsApp_Image_2025-10-24_at_10.01.24.jpg',
    alt: 'Trophy awards',
    caption: 'Trophy awards won by IGS students in various competitions'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/izoRqPZv7uCHZWbnJ1rXVJ/WhatsApp_Image_2025-10-24_at_13.20.17_%282%29.jpg',
    alt: 'Royal Camel Area Science Club trophy',
    caption: 'Winner of Schools Essay Competition in Igboland and International'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/e7k9E3co7vv9WuEz1z3ebv/WhatsApp_Image_2025-10-24_at_13.20.15_%282%29.jpg',
    alt: 'Students receiving awards at Digital Nigeria Day',
    caption: 'IGS students honored at Ogun State Bureau of Information Technology Digital Nigeria Day event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ogMkr7tVnBLYQdPxpPeZQQ/WhatsApp_Image_2025-10-24_at_13.20.15_%281%29.jpg',
    alt: 'Olawale Oshun Foundation 3rd place trophy',
    caption: '3rd place award in Best Advocate of Entrepreneurship Development Skills - Secondary School Category by Olawale Oshun Foundation (March 2023)'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/b65GAYvzP28UEyAtCCCQih/WhatsApp_Image_2025-10-24_at_13.20.16_%281%29.jpg',
    alt: 'Royal Crest Inu-kanu Club silver trophy',
    caption: 'Winner of Royal Crest Inu-kanu Club Schools Essay Competition in Ijebuland and Remoland'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eovdhC96YMzt3YwSUxupDx/WhatsApp_Image_2025-10-24_at_13.20.16.jpg',
    alt: 'Royal Crest Inu-kanu Club bronze trophy 2022',
    caption: 'Isonyin Grammar School - Winner of Royal Crest Inu-kanu Club Essay Competition 2022'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7YbpjFAQ7qHWzzGw4Denhu/WhatsApp_Image_2025-10-24_at_13.20.15.jpg',
    alt: 'Olawale Oshun Foundation award plaque',
    caption: 'Olawale Oshun Foundation award plaque for excellence in entrepreneurship education (June 2023)'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aCT9VAYd9HdMrvShJrjEdr/WhatsApp_Image_2025-11-07_at_10.22.30_%281%29.jpg',
    alt: 'Students with multiple prize checks',
    caption: 'IGS students winning multiple prizes: ₦150,000 (3rd Prize), ₦200,000 (1st Prize from FirstBank), and ₦200,000 (5th Prize) from various essay competitions'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vWrbPbCtqip5z7fhXDCzUf/WhatsApp_Image_2025-11-07_at_10.22.30.jpg',
    alt: 'Students with debate and essay competition prizes',
    caption: 'IGS students celebrating wins: ₦100,000 (3rd Prize in Ijebu Dialect Debate) and ₦150,000 (3rd Prize in Royal Crest Club Essay Competition)'
  }];
  const alumniProjectsImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/nn93xnwTcDMxPXw6huLouK/WhatsApp_Image_2025-08-14_at_15.45.40_%281%29.jpg',
    alt: 'Alumni project commissioning ceremony',
    caption: 'Alumni and dignitaries at project commissioning ceremony'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iGKm8FAGziRTZix4D1xoeG/WhatsApp_Image_2025-08-14_at_15.45.40.jpg',
    alt: 'Alumni inspecting donated classroom',
    caption: 'Alumni members inspecting newly renovated classroom'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/u8fYmTHhZVGb7kvS8fafFc/WhatsApp_Image_2025-08-14_at_15.45.39_%282%29.jpg',
    alt: 'Modern classroom facility',
    caption: 'State-of-the-art classroom donated by alumni'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dQoGZew8zGmBimUAkZ9tYb/WhatsApp_Image_2025-08-14_at_15.45.39_%281%29.jpg',
    alt: 'Alumni viewing classroom facilities',
    caption: 'Alumni association members viewing completed project'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/p35cX7359Z9n8B2uNgbpJC/WhatsApp_Image_2025-08-14_at_15.45.39.jpg',
    alt: 'Laboratory inspection by alumni',
    caption: 'Alumni inspecting upgraded laboratory facilities'
  }];
  const leadershipImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/ny9gkWcQrLZfy1eVnzqurw/WhatsApp_Image_2026-03-10_at_19.19.06_(1).jpg',
    alt: 'Principal - Mr. Olugbenga Odunaike',
    caption: 'Mr. Olugbenga Odunaike - Principal, Senior School'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2b5rD74o4Hgo2aWibDpBk6/WhatsApp_Image_2025-11-07_at_10.14.49.jpg',
    alt: 'Vice Principal - Senior School',
    caption: 'Vice Principal, Senior School'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7erE9EWw8YDTq8W8H9WSLg/WhatsApp_Image_2026-03-10_at_19.25.54.jpg',
    alt: 'Mrs. Ugwu Theresa - Principal, Junior School',
    caption: 'Mrs. Ugwu Theresa - Principal, Junior School'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2JsCMQAe6VkMkEA5ahiNJu/WhatsApp_Image_2025-11-07_at_10.17.04.jpg',
    alt: 'Vice Principal - Junior School',
    caption: 'Vice Principal, Junior School'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kCtjXZxCNmomG25TYhbjrQ/WhatsApp_Image_2025-11-07_at_10.21.13.jpg',
    alt: 'Junior School Staff',
    caption: 'Dedicated Junior School Staff in professional development session'
  }];
  return <div className="min-h-screen bg-white" data-id="element-4919">
      <PageHeader title="Photo Gallery" description="Browse photos showcasing life at Isonyin Grammar School - from our beautiful campus to vibrant student activities." backgroundImage="https://uploadthingy.s3.us-west-1.amazonaws.com/guWk5XsDGYmXXcoEtCyUpd/WhatsApp_Image_2025-10-24_at_11.30.12_%281%29.jpg" breadcrumbs={[{
      label: 'Home',
      path: '/'
    }, {
      label: 'Gallery',
      path: '/gallery'
    }]} data-id="element-4920" />
      <div className="container mx-auto px-4 py-12" data-id="element-4921">
        <Tabs tabs={[{
        id: 'campus',
        label: 'Campus & Facilities',
        content: <div className="py-6" data-id="element-4923">
                  <Gallery images={campusImages} columns={4} gap="medium" data-id="element-4924" />
                </div>
      }, {
        id: 'student-life',
        label: 'Student Life',
        content: <div className="py-6" data-id="element-4925">
                  <Gallery images={studentLifeImages} columns={4} gap="medium" data-id="element-4926" />
                </div>
      }, {
        id: 'facilities',
        label: 'Learning Facilities',
        content: <div className="py-6" data-id="element-4927">
                  <Gallery images={facilitiesImages} columns={4} gap="medium" data-id="element-4928" />
                </div>
      }, {
        id: 'achievements',
        label: 'Awards & Achievements',
        content: <div className="py-6" data-id="element-4929">
                  <div className="mb-6 text-center" data-id="element-4930">
                    <p className="text-gray-700 max-w-3xl mx-auto" data-id="element-4931">
                      Our students have won numerous awards and trophies in
                      academic competitions, sports, and cultural events. These
                      achievements reflect our commitment to excellence in all
                      areas.
                    </p>
                  </div>
                  <Gallery images={achievementsImages} columns={4} gap="medium" data-id="element-4932" />
                </div>
      }, {
        id: 'leadership',
        label: 'Leadership Team',
        content: <div className="py-6" data-id="element-4933">
                  <div className="mb-6 text-center" data-id="element-4934">
                    <p className="text-gray-700 max-w-3xl mx-auto" data-id="element-4935">
                      Meet the dedicated leadership team that guides Isonyin
                      Grammar School. Our principals and vice principals work
                      tirelessly to ensure that every student receives a
                      world-class education in a supportive environment.
                    </p>
                  </div>
                  <Gallery images={leadershipImages} columns={4} gap="medium" data-id="element-4936" />
                </div>
      }, {
        id: 'alumni-projects',
        label: 'Alumni Projects',
        content: <div className="py-6" data-id="element-4937">
                  <div className="mb-6 text-center" data-id="element-4938">
                    <p className="text-gray-700 max-w-3xl mx-auto" data-id="element-4939">
                      Our dedicated alumni continue to give back to their alma
                      mater through generous donations and project
                      commissioning. These images capture moments from various
                      alumni-funded projects that have enhanced our school's
                      infrastructure and learning environment.
                    </p>
                  </div>
                  <Gallery images={alumniProjectsImages} columns={4} gap="medium" data-id="element-4940" />
                </div>
      }]} variant="pills" data-id="element-4922" />
      </div>
    </div>;
};
export default GalleryPage;